import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import Picture from "components/ui/picture"
import { cn } from "styles/utils"

export const Container = (props) => (
  <div className="tablet:mb-80 mb-40 flex flex-col gap-16" {...props} />
)

const ArticleCard = ({ article, featured }) => {
  const { cover_image, short_description, title, url_path } = article
  const url = `/blog/${url_path}`

  return (
    <Container>
      {cover_image && (
        <Link data-lc="article-card" tabIndex="-1" to={url}>
          <Picture
            alt={cover_image.alt}
            fallback={cover_image.fallback}
            lazyload={!featured}
            srcSet={cover_image.srcSet}
          />
        </Link>
      )}
      <div>
        <Link data-lc="article-card" to={url}>
          <h2
            className={cn(
              "text-20 leading-22 mb-10 inline-block font-medium",
              featured && "tablet:text-26 tablet:leading-30 tablet:mb-24"
            )}
          >
            {title}
          </h2>
        </Link>
        <p className="text-16 leading-22 mb-16 font-light tracking-tight">
          {short_description}
        </p>
        <Button
          aria-hidden
          asChild
          className="text-16 leading-21 font-light tracking-tight"
          tabIndex="-1"
          text
          underline
          variant="secondary"
        >
          <Link data-lc="article-card" to={url}>
            Read More
          </Link>
        </Button>
      </div>
    </Container>
  )
}

ArticleCard.propTypes = {
  article: PropTypes.object,
  featured: PropTypes.bool,
}

export default ArticleCard
